import script from "./Production.vue?vue&type=script&setup=true&lang=js"
export * from "./Production.vue?vue&type=script&setup=true&lang=js"

export default script